const Loader = () => {
    return (
        <div className={`loader-spinner pl-absolute pl-top-[50%] pl-left-[50%] pl-mt-[-50px] pl-ml-[-42px] pl-w-screen pl-h-full pl-overflow-hidden`}>
            <div className="pl-bg-secondary-500"></div>
            <div className="pl-bg-secondary-500"></div>
            <div className="pl-bg-secondary-500"></div>
            <div className="pl-bg-secondary-500"></div>
            <div className="pl-bg-secondary-500"></div>
            <div className="pl-bg-secondary-500"></div>
            <div className="pl-bg-secondary-500"></div>
            <div className="pl-bg-secondary-500"></div>
            <div className="pl-bg-secondary-500"></div>
            <div className="pl-bg-secondary-500"></div>
            <div className="pl-bg-secondary-500"></div>
            <div className="pl-bg-secondary-500"></div>
        </div>
    );
};

export default Loader;
